import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  CLIENT_AUTH_CHANGED_EVENT,
  handleIsClientAuthenticated,
  isClientSessionReady,
} from "../Share/Func/Storage";
import { verifyClientSession } from "../Share/Func/clientSession";

/** Re-reads session after get-user (or logout) because cookie/memory itself is not reactive. */
export default function useClientAuthSession() {
  const location = useLocation();
  const [, setVersion] = useState(0);
  const bump = useCallback(() => setVersion((v) => v + 1), []);

  useEffect(() => {
    void verifyClientSession();
  }, [location.pathname]);

  useEffect(() => {
    bump();
  }, [location.pathname, location.search, location.hash, bump]);

  useEffect(() => {
    window.addEventListener(CLIENT_AUTH_CHANGED_EVENT, bump);
    return () => window.removeEventListener(CLIENT_AUTH_CHANGED_EVENT, bump);
  }, [bump]);

  return {
    isAuthenticated: handleIsClientAuthenticated(),
    isPending: !isClientSessionReady(),
  };
}
